import { deviceTreeWithLostDevices, moveItem_v2, } from 'console/sortableDeviceTree/utils/device-tree-utils';
import { getAPIErrorMessage } from 'api';
import { selectDeviceTree } from 'console/redux/devices/tree/selectors';
import { selectDevices } from 'entities/device/lib';
export const moveDeviceInTree = (new_group_for_device) => async (dispatch, getState, { api }) => {
    // Надо передвинуть устройство в дереве
    //и отправить на сервер изменения
    const device_tree_update_time = new Date().getTime();
    try {
        await api.update_device_tree(moveItem_v2(deviceTreeWithLostDevices(selectDeviceTree(getState()), selectDevices(getState())), new_group_for_device.old_path, new_group_for_device.new_path), device_tree_update_time);
    }
    catch (e) {
        getAPIErrorMessage(e, 'Не удалось переместить устройство');
    }
};
